import React from "react";
import {
  Building2,
  Users2,
  Calendar,
  CreditCard,
  ShieldCheck,
  FileSpreadsheet,
  Globe,
} from "lucide-react";

import ProductPage from "../Components/ProductPage";
import { colors as DS } from "../../design-system";

export default function ProductHRMS() {
  return (
    <ProductPage
      meta={{ index: "P-04", code: "HRMS" }}
      hero={{
        title: (
          <>
            Run people ops
            <br />
            <span style={{ color: `${DS.forest}80` }}>like a product.</span>
          </>
        ),
        subtitle: "Human Resource Management",
        description:
          "Onboarding, payroll, leave, performance and compliance one workspace, one source of truth, zero spreadsheets.",
        accent: DS.product.hrms,
        icon: Building2,
        animation: "dataviz",
      }}
      features={{
        title: "The full employee lifecycle, instrumented.",
        subtitle: "Every signal a manager needs, every audit trail a regulator asks for.",
        items: [
          {
            icon: Users2,
            title: "Onboarding & e-boarding",
            description: "Templated journeys, document collection and welcome flows that auto-trigger on hire.",
          },
          {
            icon: Calendar,
            title: "Time, leave & shifts",
            description: "Approval chains, statutory holidays and shift rosters by region or team.",
          },
          {
            icon: CreditCard,
            title: "Payroll & comp",
            description: "Multi-currency payroll, comp bands, equity and bonus letters in one engine.",
          },
          {
            icon: ShieldCheck,
            title: "Compliance & audit",
            description: "GDPR, SOC 2 and country-specific HR compliance, with full immutable audit logs.",
          },
          {
            icon: FileSpreadsheet,
            title: "Performance & reviews",
            description: "OKRs, 360 reviews and continuous feedback without the survey-tool tax.",
          },
          {
            icon: Globe,
            title: "Global by design",
            description: "Localised flows, languages and statutory rules across India, US, UK, CA and DE.",
          },
        ],
      }}
      flow={{
        title: "From offer letter to alumni one journey.",
        stages: [
          { title: "Onboard",  desc: "Signed offer triggers documents, kit and intro flows." },
          { title: "Operate",  desc: "Time, leave, payroll and reviews on a unified record." },
          { title: "Develop",  desc: "OKRs, learning paths and internal mobility, all linked." },
          { title: "Offboard", desc: "Exit interviews, asset return, alumni network clean handoff." },
        ],
      }}
      stats={{
        title: "Where teams land in 90 days.",
        items: [
          { value: "98%", label: "onboarding completion" },
          { value: "−45%", label: "payroll error rate" },
          { value: "12hr", label: "saved per HR-BP weekly" },
          { value: "5+",   label: "countries supported" },
        ],
      }}
      ctaPrimary={{ label: "Request demo",   href: "/contact" }}
      ctaSecondary={{ label: "Open HRMS app", href: "/hrms" }}
      finalCta={{
        title: (
          <>
            People ops without the spreadsheets.
          </>
        ),
        subtitle: "Replace 6 tools with one platform wired into your ATS, payroll provider and finance stack.",
        ctaPrimary:   { label: "Talk to sales",     href: "/contact" },
        ctaSecondary: { label: "Explore the suite", href: "/products" },
      }}
    />
  );
}
